import { CommonEnums } from 'dashboard-services/api/common';
import { DataPrepEnums } from 'dashboard-services/api/dataPrep';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { CommonService, ReduxService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

import { basicDataStorageCreatorActions as basicActions, builderDataStorageCreatorActions as builderActions } from 'actions/modules/dataStorage/creator';
import properties from 'resources/constants/properties.json';

export const builderInitialState = {
  basket: [],

  symbols: [],
  symbolsLongestGroup: 0,
  symbolsTotalSize: 0,

  infoModalOpen: false,
  infoModalSymbol: {},
  
  lastEditedGroup: undefined,
  settingsModalOpen: false,

  // right side panel
  dataRange: DataStorageEnums.DATA_RANGE.LAST,
  lastValue: 500,
  lastType: DataStorageEnums.LAST_TYPE.VALUE,
  lastTypeOnTime: "",
  lastTypeOnTimeTimezone: TimeService.UTC,
  holidayCalendar: undefined,
  deltaTransDateLimitType: undefined,
  deltaTransDateLimitAmount: undefined,

  from: undefined,
  fromTime: "00:00:00",
  fromSelected: DataStorageEnums.DATE_BETWEEN_TYPE.TODAY,

  to: undefined,
  toTime: "23:59:59",
  toSelected: DataStorageEnums.DATE_BETWEEN_TYPE.TODAY,

  timezone: undefined,
  roundingMode: "HALF_UP",
  decimalPlaces: undefined,
  skipEmptyColumns: false,
  delta: false,
  dateFormat: TimeService.BACKEND_ISO_DATE_TIME_FORMAT,
  outputLayout: DataPrepEnums.OUTPUT_LAYOUT.FAST_NCSV,
  failOnMissingSymbols: false,
  ncsvEmptySymbolsInResult: false,
  withType: false,
  attachMetadataToNcsv: properties.attachMetadataToNcsv === 'true',

  columnHeader: CommonService.isJson(localStorage.getItem("ng-storage-column-headers")) ? JSON.parse(localStorage.getItem("ng-storage-column-headers")) : builderActions.columnHeadersOptions,
  corrections: "false",
  onDateTimeOn: false,
  onDateTimeDate: undefined,
  onDateTimeTime: undefined,
  order: CommonEnums.SORT_ORDER.DESCENDING,

  basketLongestGroup: 0,

  initConfigObj: {},
  withWareHouseService: false
}

export default (state = builderInitialState, action) => {
  switch (action.type) {
    case builderActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case builderActions.ADD_ALL_TO_BASKET: {
      const newBasket = state.basket.slice()
      let basketLongestGroup = state.basketLongestGroup
      state.symbols.forEach(symbol => {
        basketLongestGroup = builderActions.getGroupWidth(symbol.groupName.length) > basketLongestGroup ? builderActions.getGroupWidth(symbol.groupName.length) : basketLongestGroup
        symbol.choosenColumns.forEach(choosenColumn => {
          newBasket.push(Object.assign({}, symbol, { values: symbol.values, choosenColumns: [choosenColumn], source: action?.provider || undefined }))
        })
      })
      return ReduxService.updateObject(state, { basket: newBasket, basketLongestGroup })
    }
    case builderActions.SYMBOLS_RESPONSE:
      return ReduxService.updateObject(state, { 
        symbols: action.items, 
        symbolsLongestGroup: builderActions.getGroupWidth(action.longestGroup) 
      })
    case builderActions.ADD_TO_BASKET:
      return ReduxService.updateObject(state, { 
        basket: state.basket.add(action.item),
        basketLongestGroup: action.item.groupName && builderActions.getGroupWidth(action.item.groupName.length) > state.basketLongestGroup ? builderActions.getGroupWidth(action.item.groupName.length) : state.basketLongestGroup
      })
    case builderActions.ADD_TO_BASKET_AT_INDEX:
      return ReduxService.updateObject(state, { 
        basket: state.basket.add(action.item, action.index),
        basketLongestGroup: action.item.groupName && builderActions.getGroupWidth(action.item.groupName.length) > state.basketLongestGroup ? builderActions.getGroupWidth(action.item.groupName.length) : state.basketLongestGroup
      })
    case builderActions.CHANGE_COLUMNS:
      return ReduxService.updateObject(state, { symbols: state.symbols.updateInList({ choosenColumns: action.value }, action.index) })
    case builderActions.REORDER_BASKET_ITEM:
      return ReduxService.updateObject(state, { basket: state.basket.moveItem(action.from, action.to) })
    case builderActions.REMOVE_FROM_BASKET: {
      const newBasket = state.basket.remove(action.index)
      return ReduxService.updateObject(state, { 
        basket: newBasket,
        basketLongestGroup: newBasket.reduce((prev, curr) => prev > builderActions.getGroupWidth(curr.groupName.length) ? prev : builderActions.getGroupWidth(curr.groupName.length), 0)
      })
    }
    case builderActions.CHANGE_BASKET_ITEM:
      return ReduxService.updateObject(state, { basket: state.basket.updateInList({ [action.name]: action.value }, action.index) })
    case basicActions.CLEAR:
      return builderInitialState;
    default:
      return state; 
  }
}